import { useEffect } from 'react';
import { useFetchTransactionTypes } from '../../../hooks/useFetchTransactionTypes';
import { useTransaction } from '../../../context/TransactionContext';
import { areStringsEqual } from '../../../constants/utilityFunctions';
import { showToast } from '../../utils/toast';
import { SystemConstants } from '../../../constants/constants';
import { useTranslation } from 'react-i18next';
import { ITransaction, ITransactionParameters } from '../../../interface/transaction';

export const useTransactionTypeDefaulting = (transactionParameters: ITransactionParameters) => {
  const { t } = useTranslation();
  const { transaction, updateTransaction } = useTransaction();

  const { data: defaultTransactionType } = useFetchTransactionTypes({
    defaultTransactionTypeId:
      transactionParameters?.transactionTypeInUse &&
      transaction?.matter?.defaultTransactionTypeId &&
      (transaction?.shouldFetchDefaultTransactionType ?? true)
        ? transaction?.matter?.defaultTransactionTypeId
        : undefined,
    fields: ['unitPrice', 'standardPrice', 'units', 'translations', 'transactionTypeUsage'],
  });

  // Validate default transaction type is hour-based
  useEffect(() => {
    if (
      defaultTransactionType &&
      transaction?.transactionType !== null &&
      !areStringsEqual(
        defaultTransactionType?.unit?.id ?? defaultTransactionType?.unitId,
        SystemConstants.UNIT_HOUR,
      )
    ) {
      showToast('info', t('transaction:defaultTransactionTypeIsNotOfUnitHour'));
      updateTransaction({
        ...transaction,
        transactionType: null,
        transactionTypeId: null,
        shouldFetchDefaultTransactionType: false,
      } as unknown as ITransaction);
    }
  }, [defaultTransactionType, transaction, updateTransaction, t]);

  return {
    defaultTransactionType,
  };
};
